import React, { PureComponent } from "react";
import { connect } from "react-redux";
import * as d3 from "d3";
import { wordCloudExclusion, toggleViewExcludedWords } from "../../../../../actions/dashboardAction";
import { deleteWordCloudItem } from "../../../../../actions/globalAction";
import WordCloudSelector from "./WordCloudSelector";
import NoData from "../NoData/NoData";
import { downloadCSVData, downloadCanvasWithTitle, toTitleCase } from "../utils";
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown";
import DimmerComponent from "../../DimmerComponent";
import html2canvas from "html2canvas";
import "../WordCloud/WordCloud.scss";
import WordcloudChart from "./WordcloudChart";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/downloads.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ReactComponent as CloseIcon } from "../../../../../assets/svg/close.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as DeleteWordCloud } from "../../../../../assets/svg/delete-wordcloud.svg";
import { ReactComponent as TranslateIcon } from "../../../../../assets/translate.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ReactComponent as RefreshWordCloud } from "../../../../../assets/svg/refresh.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import Scrollbars from "react-custom-scrollbars";
import { toast } from "react-toastify";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import TranslateWords from "./TranslateWords";

class OCRWordCloud extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            selectedWord: [],
            translateWords: false,
        };
        this.chartEl = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.viewExcludedWords !== this.props.viewExcludedWords && !this.props.viewExcludedWords && this.props.wordcloudWordUnexcluded) {
            this.resetData();
        }
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = this.props.data.map((word) => [word.name, word.weight]);

        csvFmt.unshift(["Word", "Count"]);

        downloadCSVData(csvFmt, this.props.widget.name);
    };

    downloadPNG = (options) => {
        this.setState({ downloading: true });
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        // document.getElementsByClassName("list-words")[0].style.display = "none";
        this.setState({ downloading: true });
        html2canvas(this.chartEl.current, { backgroundColor: options ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            this.setState({ downloading: false });
            // document.getElementsByClassName("list-words")[0].style.display = "flex";
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    drillDownWordCloseHandle = (word) => {
        let drillDownWord = this.props.wordCloudDrilldownWords.filter((w) => w !== word);
        this.props.stateUpdate({ wordCloudDrilldownWords: drillDownWord });
        this.props.fetchDataFromWidget({
            ocr_wordcloud_drilldown_query: drillDownWord.join(" + "),
        });
    };

    handleContextMenuClick = (cluster_keyword) => {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        newFilter.extras = [{ key: "OCR Drilled Down Words", value: [cluster_keyword] }];
        if (this.props.appliedFilter.aggs === "ocr-impact-wordcloud") newFilter.orderBy = "impact_value";

        if (this.props.drilldown_charts) {
            newFilter = this.props.drilldown_filters && this.props.drilldown_filters.filter;
            if (newFilter.extras) newFilter.extras.push({ key: "Drilled Down Words", value: [cluster_keyword.toLowerCase()] });
            else newFilter.extras = [{ key: "Drilled Down Words", value: [cluster_keyword.toLowerCase()] }];
        }

        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick = (cluster_keyword) => {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        if (this.props.drilldown_charts) newFilter = this.props.drilldown_filters && this.props.drilldown_filters.filter;

        newFilter.extras = [{ key: "OCR Drilled Down Words", value: [cluster_keyword] }];
        this.props.handleDrilldownClick(newFilter);
    };

    handleAggsChange = (val) => {
        this.props.fetchDataFromWidget({
            aggs: val,
        });
    };

    showContextMenu = (x, y, cluster_keyword, type) => {
        if (this.props.isPublic) return;
        if (!this.props.drilldown_charts) {
            let contextMenu = d3.select(".dashboard-charts-contextmenu");
            contextMenu.attr("data-type", "clickedMenu");
            contextMenu.style("top", `${y + 10}px`);
            contextMenu.style("left", `${x - 82}px`);
            contextMenu.style("background", `#fff`);
            contextMenu.style("color", `#1a1a1a`);
            contextMenu.html(null);
            if (type === "delete") {
                contextMenu
                    .append("li")
                    .text("View Conversations")
                    .on("click", () => {
                        this.handleContextMenuClick(cluster_keyword);
                    });
                !this.props.drilldown_charts &&
                    contextMenu
                        .append("li")
                        .text("View Insights")
                        .on("click", () => {
                            // console.log('drilldown')
                            this.handleDrilldownClick(cluster_keyword);
                            // this.props.showChartsDrilldown(true, "wordcloud");
                        });
                contextMenu
                    .append("li")
                    .text("Exclude Word")
                    .on("click", () => {
                        this.excludeWord(cluster_keyword);
                    });
            } else {
                contextMenu
                    .append("li")
                    .text("Undo Exclude")
                    .on("click", () => {
                        this.undoExcludeWord(cluster_keyword);
                    });
            }
            contextMenu.style("display", "block");
        }
    };

    escapeSpecialCaseChar(text) {
        return text.replace(/[-[\]{}()*+?/.,\\^$|#\s]/g, "\\$&");
    }

    excludeWord = (word) => {
        this.props
            .wordCloudExclusion({
                user_id: this.props.user.id,
                company_id: this.props.company.company_id,
                words: [word],
            })
            .then(() => {
                this.setState({ selectedWord: [...this.state.selectedWord, word] });
            });
    };

    undoExcludeWord = (word) => {
        this.props.deleteWordCloudItem({ companyId: this.props.company.company_id, word }).then((res) => {
            if (res?.data?.status === "success") {
                this.setState({ selectedWord: this.state.selectedWord.filter((w) => w !== word) });
                toast.success("Word removed from exclusion list");
            }
        });
    };

    renderDownloadButton = (nodata) => {
        return (
            <Dropdown
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    <Dropdown.Item onClick={this.downloadCSV}>CSV</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(true)}>PNG</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(false)}>PNG(Transparent)</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    onChangeSelectedWord = (word) => {
        let selectedWord = this.state.selectedWord;
        selectedWord.push(word);
        selectedWord = _.uniq(selectedWord);
        this.setState({ selectedWord });
    };

    drillDown = (e) => {
        let drillDownWord = this.props.wordCloudDrilldownWords?.length ? this.props.wordCloudDrilldownWords : [];

        // let drillDownWord = this.props.wordCloudDrilldownWords?.length ? this.props.wordCloudDrilldownWords : [];
        drillDownWord && drillDownWord.push(e);
        drillDownWord = _.uniq(drillDownWord);
        this.props.stateUpdate({ wordCloudDrilldownWords: drillDownWord });
        this.props.fetchDataFromWidget({
            ocr_wordcloud_drilldown_query: drillDownWord.join(" AND "),
        });
    };

    removeWord = (word) => {
        this.setState({ selectedWord: this.state.selectedWord.filter((item) => item !== word) });
    };

    getRestNames = (members) => {
        let elements = (
            <div className={`rest-members ${members.length > 4 ? "" : "rest-members-auto"}`}>
                {members.map((member) => {
                    let index = member.split("").findIndex((x) => {
                        return x === "\\";
                    });
                    if (index > 0) {
                        member = member.split("");
                        member[index + 1] = "+ ";
                        member[index] = "";
                        member = member.join("");
                    }
                    return (
                        <div className="word-rest" key={member}>
                            <span>{member.toUpperCase()}</span>
                            <span className="close-icon" onClick={() => this.drillDownWordCloseHandle(member)}>
                                <CloseIcon />
                            </span>
                        </div>
                    );
                })}
            </div>
        );

        return members.length > 4 ? <Scrollbars>{elements}</Scrollbars> : elements;
    };

    getWordsToBeDeleted = () => {
        let totalWidth = this.props.widgetContainerRef && this.props.widgetContainerRef.current && this.props.widgetContainerRef.current.offsetWidth;
        let el = document.getElementById("wordcloud-word-length-test");
        if (!totalWidth) return null;
        if (el === null) {
            this.forceUpdate();
            return null;
        }

        let drillArr = this.props.wordCloudDrilldownWords;

        if (drillArr.length === 0) return null;
        let words = [];
        let extraWords = [];

        let lengthCovered = 0;

        drillArr
            .sort((a, b) => a.length - b.length)
            .forEach((d) => {
                el.innerHTML = d.toUpperCase();

                const clientWidth = el.clientWidth;

                let x = clientWidth;
                if (x > 100) x = 100;
                x += 42;
                if (lengthCovered + x < totalWidth - 42) {
                    words.push(d);
                    lengthCovered += x;
                } else extraWords.push(d);
            });

        let elements = words.map((word) => {
            let index = word.split("").findIndex((x) => {
                return x === "\\";
            });
            if (index > 0) {
                word = word.split("");
                word[index + 1] = "+ ";
                word[index] = "";
                word = word.join("");
            }
            return (
                <div className="word" title={word} key={word}>
                    <span className="word-item">{word.toUpperCase()}</span>
                    <CloseIcon onClick={() => this.drillDownWordCloseHandle(word)} className="close-icon" />
                </div>
            );
        });

        return (
            <>
                {elements}
                {extraWords.length ? (
                    <Popup
                        className={`skiptranslate remNamesPopup ${extraWords.length > 4 ? " remNamesPopup-scrollable" : ""}`}
                        trigger={<span className="word">+{extraWords.length}</span>}
                        on="click"
                        content={() => this.getRestNames(extraWords)}
                        position="bottom right"
                        hoverable={true}
                        inverted
                    />
                ) : null}
            </>
        );
    };

    getWordsBar = () => {
        return (
            <div data-html2canvas-ignore className="list-words">
                <div className="selected-word">{this.getWordsToBeDeleted()}</div>
            </div>
        );
    };

    resetData = () => {
        this.props.fetchDataFromWidget();
    };

    viewExcludedWords = () => {
        this.props.toggleViewExcludedWords(true);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.length === 0) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info={`
                        The OCR Word Cloud gives you the top words or phrases that were mentioned in the image in a text form.  We use Optical Character Recognition to detect text in images.  Click on a word to open a second-level Word Cloud, and keep going deeper in a specific trend to garner better insights. To delete an irrelevant word from the Word Cloud, simply right click on the word and click "Exclude Word". To undo, right click on the deleted word and click "Undo Exclude". You can check the list of excluded words from the side menu.`}
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {this.state.selectedWord?.length > 0 && (
                            <Popup
                                trigger={
                                    <div className="chart-header-icon refresh">
                                        <RefreshWordCloud onClick={this.resetData} />
                                    </div>
                                }
                                content="Refresh data"
                                inverted
                                size="tiny"
                                position="bottom center"
                            />
                        )}
                        {!nodata && (
                            <Popup
                                trigger={
                                    <div className="chart-header-icon refresh" onClick={() => this.setState({ translateWords: true })}>
                                        <TranslateIcon />
                                    </div>
                                }
                                content="Translate OCR Wordcloud words"
                                inverted
                                size="tiny"
                                className="skiptranslate"
                                position="left center"
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata
                                    ? null
                                    : !this.props.drilldown_charts && (
                                          <Popup
                                              className="skiptranslate"
                                              trigger={
                                                  this.props.expandWidget ? (
                                                      <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  ) : (
                                                      <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  )
                                              }
                                              inverted
                                              content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                              size="mini"
                                              position="bottom center"
                                              style={{ zIndex: "99999" }}
                                          />
                                      )}
                            </>
                        }
                        {(this.props.isPublic && nodata) || this.props.drilldown_charts ? null : (
                            <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && !this.props.drilldown_charts && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <WordCloudSelector appliedFilter={this.props.appliedFilter} handleAggsChange={(val) => this.handleAggsChange(val)} />}
                        {!this.props.isPublic && (
                            <div className="menu-option" onClick={this.viewExcludedWords}>
                                <span>View Excluded Words</span>
                            </div>
                        )}

                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                <div id="wordcloud-word-length-test"></div> {/* test div getting used for loading words bar */}
                {!nodata ? (
                    <div className="dashboard-chart wordcloud-chart skiptranslate" ref={this.chartEl}>
                        {!nodata && this.props.wordCloudDrilldownWords?.length ? this.getWordsBar() : ""}
                        <WordcloudChart
                            showContextMenu={this.showContextMenu}
                            drillDown={this.drillDown}
                            data={this.props.data}
                            selectedWord={this.state.selectedWord}
                            appliedFilter={this.props.appliedFilter}
                            hasDrilldownWords={this.props.wordCloudDrilldownWords?.length}
                            onChangeSelectedWord={this.onChangeSelectedWord}
                            // resizedCount={this.props.resizedCount}
                            widgetContainerRef={this.props.widgetContainerRef}
                        />
                        {this.state.downloading && <DimmerComponent />}
                    </div>
                ) : (
                    <>
                        {!!this.props.wordCloudDrilldownWords?.length && this.getWordsBar()}
                        <NoData
                            message={
                                !this.props.isPublic && this.props.noTopicsSelected
                                    ? this.props.chartFilterApplied
                                        ? "Please select topics in the chart filters to view data."
                                        : "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                    : null
                            }
                        />
                    </>
                )}
                <TranslateWords data={this.props.data} open={this.state.translateWords} onClose={() => this.setState({ translateWords: false })} />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.globalReducer.user,
        company: state.globalReducer.company,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,

        viewExcludedWords: state.dashboardReducer.viewExcludedWords,
        wordcloudWordUnexcluded: state.dashboardReducer.wordcloudWordUnexcluded,
        drilldown_filters: state.dashboardReducer.drilldown_filters,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
        wordCloudExclusion: (data) => dispatch(wordCloudExclusion(data)),
        deleteWordCloudItem: (data) => dispatch(deleteWordCloudItem(data)),
        toggleViewExcludedWords: (data) => dispatch(toggleViewExcludedWords(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OCRWordCloud);
